import React from 'react';

/** Pass-through shell — home overlays removed for a cleaner Ally-style experience. */
const VisitIntentWrapper = ({ children }) => <>{children}</>;

export default VisitIntentWrapper;
